import React, { Suspense, startTransition } from 'react';
import Error500 from '../components/Error500/Error500';
import Spinner from "../components/Spinner/Spinner";
class ErrorBoundary extends React.Component {
  state = {
    errorMessage: ''
  };

  static getDerivedStateFromError(error) {
    return { errorMessage: error.toString() };
  }

  componentDidCatch(error, info) {
    // Wrap the state update in startTransition to avoid UI blocking
    startTransition(() => {
      this.setState({'pathname' : window.location.pathname});
      this.logErrorToServices(error.toString(), info.componentStack);
    });
  }

  // Logging service placeholder; replace with a real logging solution
  logErrorToServices = (error, info) => {
    console.error("Logging error:", error, info);
  };

  render() {
    if (this.state.errorMessage) {
      return <Error500 error={this.state.errorMessage} />;
    }

    return (
      <Suspense fallback={<Spinner />}>
        {this.props.children}
      </Suspense>
    );
  }
}

export default ErrorBoundary;
